import { RequestQuery } from 'utils/types/request-types';

export const makeQuery = (values: Record<string, unknown>): RequestQuery =>
	JSON.parse(JSON.stringify(values)) as RequestQuery;
